import { useNavigate } from 'react-router-dom'

import * as Routes from '../../routing/constants'

export const useNavigateFromOnboardingPropertySelection = () => {
  const navigate = useNavigate()
  return () => navigate(Routes.Onboarding.RENT_AMOUNT)
}
